import { FilterProvider } from "~/components/ultra-filter/types";
import React from "react";
import { FilterProviderProps } from "~/filterProviders/types";
import { createSimpleProvider } from "~/filterProviders/createSimpleProvider";
import { CompanyRolePicker } from "~/roles/CompanyRolePicker";
import { useCompanyRoles } from "~/refdata2/companyRoles";

export function useCompanyRoleProvider(
  props: FilterProviderProps
): FilterProvider {
  const roles = useCompanyRoles() ?? [];
  const options = roles.map((x) => ({
    text: x,
    value: x,
  }));

  return createSimpleProvider({
    documentationText: props.documentationText,
    type: "role",
    label: "Role",
    render: () => (
      <CompanyRolePicker formField="role" label="Role" helperText="" />
    ),
    suggestText: "role",
    options,
  });
}
